import { Route } from '@/app/router'

const Conditions = () => import('./index.vue')
const ConditionsProps = ['page', 'perPage']

export default new Route('/condition-types', Conditions)
	.as('Dashboard:ConditionTypes')
	.props(ConditionsProps)
	// .permissions(['CREATE_CATEGORY_SET'])
